export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--3-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CartItem.vue?vue&type=template&id=2c8c4cf2"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/CartItem.vue?vue&type=template&id=2c8c4cf2
// module id = 124
// module chunks = 0